import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

// Components
import { YellowButton, BlueButton } from "./Buttons";

// Assets
import logoImg from "../assets/core/img/logo.png";

export default function LogoBox() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <div className="mt-5 px-[5vw] 2xl:px-[15vw]">
      <div className="flex flex-col items-center justify-center relative">
        <div className="h-full w-[70vw] sm:w-56 xl:w-80 2xl:w-96">
          <img
            src={logoImg}
            alt="logo"
            className="h-full w-full"
            onClick={() => {
              navigate("/");
            }}
          />
        </div>

        {pathname === "/signup" ? (
          <div className="w-[70vw] sm:w-56 md:w-3/12 xl:w-80 mt-5 md:mt-0 md:absolute md:right-0">
            <BlueButton
              onClick={() => {
                navigate("/signin");
              }}
            >
              Sign In
            </BlueButton>
          </div>
        ) : pathname === "/signin" ? (
          <div className="w-[70vw] sm:w-56 md:w-3/12 xl:w-80 mt-5 md:mt-0 md:absolute md:right-0">
            <YellowButton
              onClick={() => {
                navigate("/signup");
              }}
            >
              Sign Up
            </YellowButton>
          </div>
        ) : null}
      </div>
    </div>
  );
}
